(function () {
  'use strict';

  var bar = document.querySelector('[data-fd-privacy]');
  if (!bar) return;

  var settings = bar.querySelector('[data-fd-privacy-settings]');
  var manageButton = bar.querySelector('[data-fd-privacy-manage]');
  var api = null;
  var started = false;

  function loadScript(id, src) {
    if (document.getElementById(id)) return;
    var script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = src;
    document.head.appendChild(script);
  }

  function syncOptionalScripts() {
    if (!api) return;

    // Shopify app pixels (including advertising and analytics integrations) are
    // governed by this same API. Klaviyo is loaded manually, so gate it here.
    if (api.marketingAllowed()) {
      loadScript('fd-klaviyo-onsite', 'https://static.klaviyo.com/onsite/js/VaBXBk/klaviyo.js');
    }

    // Clarity runs in the top frame so session recordings contain the actual
    // storefront DOM. Keep its Consent V2 state aligned with Shopify privacy.
    if (typeof window.clarity === 'function') {
      window.clarity('consentv2', {
        ad_Storage: api.marketingAllowed() ? 'granted' : 'denied',
        analytics_Storage: api.analyticsProcessingAllowed() ? 'granted' : 'denied'
      });
    }
  }

  function currentChoice(name) {
    var consent = api.currentVisitorConsent();
    if (consent[name] === 'yes') return true;
    if (consent[name] === 'no') return false;

    if (name === 'preferences') return api.preferencesProcessingAllowed();
    if (name === 'analytics') return api.analyticsProcessingAllowed();
    return api.marketingAllowed();
  }

  function populateChoices() {
    bar.querySelectorAll('[data-fd-consent]').forEach(function (input) {
      input.checked = currentChoice(input.getAttribute('data-fd-consent'));
    });
  }

  function openBar(showSettings) {
    populateChoices();
    bar.hidden = false;
    settings.hidden = !showSettings;
    manageButton.setAttribute('aria-expanded', showSettings ? 'true' : 'false');
    if (showSettings) {
      var firstChoice = settings.querySelector('input');
      if (firstChoice) firstChoice.focus();
    }
  }

  function closeBar() {
    bar.hidden = true;
    settings.hidden = true;
    manageButton.setAttribute('aria-expanded', 'false');
  }

  function saveConsent(choice) {
    var revokeLoadedMarketing = api.marketingAllowed() && choice.marketing === false;

    api.setTrackingConsent(choice, function () {
      closeBar();
      syncOptionalScripts();

      // A reload is the only reliable way to stop a third-party script that was
      // already loaded before a visitor later withdrew consent.
      if (revokeLoadedMarketing) window.location.reload();
    });
  }

  bar.querySelector('[data-fd-privacy-reject]').addEventListener('click', function () {
    saveConsent({ preferences: false, analytics: false, marketing: false });
  });

  bar.querySelector('[data-fd-privacy-accept]').addEventListener('click', function () {
    saveConsent({ preferences: true, analytics: true, marketing: true });
  });

  manageButton.addEventListener('click', function () {
    var willOpen = settings.hidden;
    settings.hidden = !willOpen;
    manageButton.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) populateChoices();
  });

  bar.querySelector('[data-fd-privacy-save]').addEventListener('click', function () {
    var choice = {};
    bar.querySelectorAll('[data-fd-consent]').forEach(function (input) {
      choice[input.getAttribute('data-fd-consent')] = input.checked;
    });
    saveConsent(choice);
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fd-open-privacy]');
    if (!trigger) return;
    event.preventDefault();
    openBar(true);
  });

  document.addEventListener('visitorConsentCollected', syncOptionalScripts);

  function initializePrivacy(attempt) {
    if (started) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (attempt < 40) window.setTimeout(function () { initializePrivacy(attempt + 1); }, 100);
      return;
    }

    started = true;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) {
          started = false;
          return;
        }

        api = window.Shopify.customerPrivacy;
        document.documentElement.classList.add('fd-custom-privacy-ready');
        syncOptionalScripts();

        if (api.shouldShowBanner()) openBar(false);
      }
    );
  }

  initializePrivacy(0);
})();
